const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const Video = require('../../io/video');
const tf = require('@tensorflow/tfjs');
const cocoSsd = require('@tensorflow-models/coco-ssd');
const StageLayering = require('../../engine/stage-layering');
const menuIconURI = `data:image/png;base64,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`

class Scratch3ObjectDetectionExtension {
    constructor(runtime) {
        this.runtime = runtime;
        this.video = this.runtime.ioDevices.video;
        this.model = null;
        this.boundingBoxes = [];
        this.modelLoaded = false;
        this.videoReady = false;
        this.videoCheckInterval = null;
        this.boundingBoxes = [];
        this.detectedClasses = new Set();
        this.confidenceThreshold = 0.3;
        this._initialize();
        this.penSkinId = -1;
        this.penDrawableId = -1;
        this._initializePenLayer();

        // Turn off camera and clear drawings when a project is loaded or switched
        this._onProjectLoaded = this._cleanup.bind(this);
        if (this.runtime) {
            this.runtime.on('PROJECT_LOADED', this._onProjectLoaded);
            this.runtime.on('RUNTIME_DISPOSED', this._onProjectLoaded);
        }
    }


    _createLoadingUI() {
        // Create overlay first
        const overlay = document.createElement('div');
        overlay.className = 'stemblocks-detection-overlay';
        overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(3px);
        z-index: 999;
    `;
        document.body.appendChild(overlay);

        // Create style element for animations
        const styleSheet = document.createElement('style');
        styleSheet.textContent = `
        @keyframes spin {
            to { transform: rotate(360deg); }
        }
        @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
        }
        @keyframes scale {
            0% { transform: scale(0.5); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
        }
        @font-face {
            font-family: 'Comic Sans MS';
            src: local('Comic Sans MS');
        }
    `;
        document.head.appendChild(styleSheet);

        // Create popup container
        const popup = document.createElement('div');
        popup.className = 'stemblocks-detection-popup';
        popup.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(135deg, #6e8efb, #a777e3);
        color: white;
        padding: 25px 30px;
        border-radius: 20px;
        z-index: 1000;
        font-family: 'Comic Sans MS', 'Marker Felt', 'Arial Rounded MT Bold', sans-serif;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
        min-width: 280px;
        text-align: center;
        border: 4px solid white;
    `;

        // Create spinner with fun design
        const spinner = document.createElement('div');
        spinner.style.cssText = `
        width: 60px;
        height: 60px;
        border: 5px solid rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        border-top-color: white;
        animation: spin 1s ease-in-out infinite;
        box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
    `;

        // Create title with emoji
        const title = document.createElement('div');
        title.style.cssText = `
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0.5px;
        color: #fff;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    `;
        title.innerHTML = '🤖 Loading AI Model...';

        // Create message text
        const message = document.createElement('div');
        message.style.cssText = `
        font-size: 16px;
        opacity: 0.9;
        margin-top: -5px;
    `;
        message.textContent = 'Please wait while model is being loaded!';

        // Create fun loading animation
        const loadingDots = document.createElement('div');
        loadingDots.style.cssText = `
        display: flex;
        gap: 8px;
        margin-top: 5px;
    `;

        // Add bouncing dots
        for (let i = 0; i < 3; i++) {
            const dot = document.createElement('div');
            dot.style.cssText = `
            width: 12px;
            height: 12px;
            background-color: white;
            border-radius: 50%;
            animation: bounce 0.8s ease-in-out infinite;
            animation-delay: ${i * 0.15}s;
        `;
            loadingDots.appendChild(dot);
        }

        // Assemble popup
        popup.appendChild(title);
        popup.appendChild(spinner);
        popup.appendChild(message);
        popup.appendChild(loadingDots);
        document.body.appendChild(popup);

        return { popup, spinner, title, message, loadingDots, overlay };
    }

    // Update UI for success state
    _showSuccessUI(elements) {
        const { popup, spinner, title, message, loadingDots, overlay } = elements;

        // Update spinner to success icon
        spinner.style.borderWidth = '0';
        spinner.innerHTML = '✨';
        spinner.style.cssText = `
        width: 70px;
        height: 70px;
        background: #4ede4e;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 40px;
        color: white;
        animation: scale 0.5s ease-in-out;
        box-shadow: 0 0 20px rgba(78, 222, 78, 0.5);
    `;

        // Update text
        title.innerHTML = '🎉 All Ready!';
        message.textContent = 'Model loaded successfully!';

        // Remove loading dots
        if (loadingDots.parentNode === popup) {
            popup.removeChild(loadingDots);
        }

        // Fade out and remove
        setTimeout(() => {
            if (document.body.contains(popup)) {
                popup.style.opacity = '0';
                overlay.style.opacity = '0';
                popup.style.transform = 'translate(-50%, -50%) scale(0.8)';
                popup.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                overlay.style.transition = 'opacity 0.6s ease';
                setTimeout(() => {
                    if (document.body.contains(popup)) {
                        document.body.removeChild(popup);
                        document.body.removeChild(overlay);
                    }
                }, 600);
            }
        }, 1500);
    }

    // Update UI for error state
    _showErrorUI(elements) {
        const { popup, spinner, title, message, loadingDots, overlay } = elements;

        // Update spinner to error icon
        spinner.style.cssText = `
        width: 70px;
        height: 70px;
        background: #ff6b6b;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 40px;
        color: white;
        box-shadow: 0 0 20px rgba(255, 107, 107, 0.5);
    `;
        spinner.innerHTML = '😕';

        // Update text
        title.innerHTML = 'Oops! Something went wrong';
        message.textContent = 'Try refreshing the page or check your internet!';

        // Remove loading dots
        if (loadingDots.parentNode === popup) {
            popup.removeChild(loadingDots);
        }

        // Add retry button
        const retryButton = document.createElement('button');
        retryButton.textContent = 'Try Again';
        retryButton.style.cssText = `
        background: white;
        color: #ff6b6b;
        border: none;
        border-radius: 30px;
        padding: 10px 20px;
        font-family: inherit;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        margin-top: 10px;
        transition: all 0.2s;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    `;
        retryButton.onmouseover = () => {
            retryButton.style.transform = 'scale(1.05)';
        };
        retryButton.onmouseout = () => {
            retryButton.style.transform = 'scale(1)';
        };
        retryButton.onclick = () => {
            if (document.body.contains(popup)) {
                document.body.removeChild(popup);
                document.body.removeChild(overlay);
            }
            this._initialize(); // Restart initialization
        };
        popup.appendChild(retryButton);

        // Fade out after longer time
        setTimeout(() => {
            if (document.body.contains(popup)) {
                popup.style.opacity = '0';
                overlay.style.opacity = '0';
                popup.style.transform = 'translate(-50%, -50%) scale(0.8)';
                popup.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                overlay.style.transition = 'opacity 0.6s ease';
                setTimeout(() => {
                    if (document.body.contains(popup)) {
                        document.body.removeChild(popup);
                        document.body.removeChild(overlay);
                    }
                }, 600);
            }
        }, 5000);
    }

    async _initialize() {
        await tf.ready();
        // Create and show loading UI
        const uiElements = this._createLoadingUI();
        // Wait for the video to be ready
        // await this._waitForVideo();
        try {
            this.model = await cocoSsd.load({
              base: 'mobilenet_v2'  // More accurate than default mobilenet_v1
            });
            this.modelLoaded = true;
            console.log('CocoSSD model loaded successfully');

            // Show success UI
            this._showSuccessUI(uiElements);
        } catch (error) {
            console.error('Failed to load CocoSSD model:', error);

            // Show error UI
            this._showErrorUI(uiElements);
        }
    }

    async _waitForVideo() {
        return new Promise(resolve => {
            const checkVideo = () => {
                if (this.video.videoReady) {
                    resolve();
                } else {
                    setTimeout(checkVideo, 100);
                }
            };
            checkVideo();
        });
    }

    _getObjectIndexMenu() {
        const menuItems = [];
        for (let i = 1; i <= this.boundingBoxes.length; i++) {
            menuItems.push({ text: String(i), value: String(i) });
        }
        return menuItems.length > 0 ? menuItems : [{ text: '1', value: '1' }];
    }

    getObjectIndexMenu() {
        return this._getObjectIndexMenu();
    }

    getInfo() {
        return {
            id: 'object',
            color1: '#e8ce09',
            blockIconURI: menuIconURI,
            menuIconURI: menuIconURI,
            name: formatMessage({
                id: 'object.categoryName',
                default: 'Object Detection',
                description: 'Label for the object detection extension category'
            }),
            blocks: [
                {
                    opcode: 'videoToggle',
                    text: formatMessage({
                        id: 'object.videoToggle',
                        default: 'turn video [VIDEO_STATE]',
                        description: 'Controls display of the video preview layer'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        VIDEO_STATE: {
                            type: ArgumentType.STRING,
                            menu: 'VIDEO_STATE',
                            defaultValue: 'on'
                        }
                    }
                },
                {
                    opcode: 'setConfidenceThreshold',
                    text: formatMessage({
                        id: 'object.setConfidenceThreshold',
                        default: 'set detection confidence to [THRESHOLD]',
                        description: 'Sets the confidence threshold for object detection'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        THRESHOLD: {
                            type: ArgumentType.NUMBER,
                            menu: 'confidenceThresholdMenu',
                            defaultValue: '0.3'
                        }
                    }
                },
                {
                    opcode: 'detectObject',
                    text: formatMessage({
                        id: 'object.detectObject',
                        default: 'detect objects and [SHOW_BOUNDING_BOX] bounding box',
                        description: 'Detects objects and shows or hides the bounding box'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        SHOW_BOUNDING_BOX: {
                            type: ArgumentType.STRING,
                            menu: 'SHOW_BOUNDING_BOX',
                            defaultValue: 'show'
                        }
                    }
                },
                {
                    opcode: 'getDetectedObjectCount',
                    text: formatMessage({
                        id: 'object.getDetectedObjectCount',
                        default: 'number of detected objects',
                        description: 'Returns the number of objects detected in the last scan'
                    }),
                    blockType: BlockType.REPORTER
                },
                {
                    opcode: 'getDetectedObjectProperty',
                    text: formatMessage({
                        id: 'object.getDetectedObjectProperty',
                        default: '[PROPERTY] of detected object [OBJECT_INDEX]',
                        description: 'Returns the specified property of a detected object by index'
                    }),
                    blockType: BlockType.REPORTER,
                    arguments: {
                        PROPERTY: {
                            type: ArgumentType.STRING,
                            menu: 'objectPropertyMenu',
                            defaultValue: 'class'
                        },
                        OBJECT_INDEX: {
                            type: ArgumentType.NUMBER,
                            menu: 'objectIndexMenu',
                            defaultValue: 1
                        }
                    }
                },
                {
                    opcode: 'isClassDetected',
                    text: formatMessage({
                        id: 'object.isClassDetected',
                        default: 'is [CLASS] detected?',
                        description: 'Returns true if the specified class is detected'
                    }),
                    blockType: BlockType.BOOLEAN,
                    arguments: {
                        CLASS: {
                            type: ArgumentType.STRING,
                            menu: 'detectedClassesMenu',
                            defaultValue: 'person' // Empty string as default
                        }
                    }
                },
                {
                    opcode: 'getClassCount',
                    text: formatMessage({
                        id: 'object.getClassCount',
                        default: 'number of [CLASS] detected',
                        description: 'Returns the number of detected objects of a specific class'
                    }),
                    blockType: BlockType.REPORTER,
                    arguments: {
                        CLASS: {
                            type: ArgumentType.STRING,
                            menu: 'detectedClassesMenu',
                            defaultValue: 'person'
                        }
                    }
                },
                {
                    opcode: 'clearCanvas',
                    text: formatMessage({
                        id: 'object.clearCanvas',
                        default: 'clear canvas',
                        description: 'Clears the canvas of all bounding boxes'
                    }),
                    blockType: BlockType.COMMAND
                }

            ],
            menus: {
                VIDEO_STATE: {
                    acceptReporters: true,
                    items: this._buildMenu([
                        { name: 'on', value: 'on' },
                        { name: 'off', value: 'off' }
                    ])
                },
                SHOW_BOUNDING_BOX: {
                    acceptReporters: true,
                    items: this._buildMenu([
                        { name: 'show', value: 'show' },
                        { name: 'hide', value: 'hide' }
                    ])
                },
                objectIndexMenu: {
                    acceptReporters: true,
                    items: 'getObjectIndexMenu'
                },
                objectPropertyMenu: {
                    acceptReporters: false,
                    items: [
                        { text: 'class', value: 'class' },
                        { text: 'x position', value: 'x' },
                        { text: 'y position', value: 'y' },
                        { text: 'width', value: 'width' },
                        { text: 'height', value: 'height' },
                        { text: 'confidence', value: 'confidence' }
                    ]
                },
                detectedClassesMenu: {
                    acceptReporters: false,
                    items: [
                        'person', 'bicycle', 'car', 'motorcycle', 'airplane', 'bus', 'train', 'truck', 'boat',
                        'traffic light', 'fire hydrant', 'stop sign', 'parking meter', 'bench', 'bird', 'cat',
                        'dog', 'horse', 'sheep', 'cow', 'elephant', 'bear', 'zebra', 'giraffe', 'backpack',
                        'umbrella', 'handbag', 'tie', 'suitcase', 'frisbee', 'skis', 'snowboard', 'sports ball',
                        'kite', 'baseball bat', 'baseball glove', 'skateboard', 'surfboard', 'tennis racket',
                        'bottle', 'wine glass', 'cup', 'fork', 'knife', 'spoon', 'bowl', 'banana', 'apple',
                        'sandwich', 'orange', 'broccoli', 'carrot', 'hot dog', 'pizza', 'donut', 'cake', 'chair',
                        'couch', 'potted plant', 'bed', 'dining table', 'toilet', 'tv', 'laptop', 'mouse', 'remote',
                        'keyboard', 'cell phone', 'microwave', 'oven', 'toaster', 'sink', 'refrigerator', 'book',
                        'clock', 'vase', 'scissors', 'teddy bear', 'hair drier', 'toothbrush'
                    ]
                },
                confidenceThresholdMenu: {
                    acceptReporters: true,
                    items: ['0', '0.1', '0.2', '0.3', '0.4', '0.5', '0.6', '0.7', '0.8', '0.9', '1']
                }
            }
        };
    }

    _buildMenu(info) {
        return info.map(entry => ({
            text: entry.name,
            value: entry.value
        }));
    }

    async detectObject(args) {
        if (!this.modelLoaded) {
            console.log('Model is still loading, please wait...');
            return;
        }
        if (!this.video.videoReady) {
            console.log('Video is not ready, please wait...');
            return;
        }
        const showBoundingBox = args.SHOW_BOUNDING_BOX === 'show';
        try {
            const videoFrame = this.video.getFrame({ format: Video.FORMAT_CANVAS });

            if (!videoFrame) {
                console.log('No video frame available');
                return;
            }

            // Original video dimensions
            const originalWidth = videoFrame.width;
            const originalHeight = videoFrame.height;

            // Fixed video dimensions (Scratch stage dimensions)
            const fixedWidth = 480;
            const fixedHeight = 360;

            // Calculate scaling factors
            const scaleX = fixedWidth / originalWidth;
            const scaleY = fixedHeight / originalHeight;

            // Run detection
            const predictions = await this.model.detect(videoFrame);
            this.boundingBoxes = predictions
                .filter(prediction => prediction.score >= this.confidenceThreshold)
                .map(prediction => {
                    // Scale the bounding box coordinates
                    const scaledX = prediction.bbox[0] * scaleX;
                    const scaledY = prediction.bbox[1] * scaleY;
                    const scaledWidth = prediction.bbox[2] * scaleX;
                    const scaledHeight = prediction.bbox[3] * scaleY;

                    // Center the coordinates on the Scratch stage
                    const centeredX = (fixedWidth / 2) + scaledX - (fixedWidth / 2);
                    const centeredY = (fixedHeight / 2) + scaledY - (fixedHeight / 2);

                    return {
                        x: centeredX,
                        y: centeredY,
                        width: scaledWidth,
                        height: scaledHeight,
                        class: prediction.class,
                        score: prediction.score
                    };
                });

            this.detectedClasses = new Set(this.boundingBoxes.map(box => box.class));
            this.runtime.requestToolboxExtensionsUpdate();

            if (showBoundingBox) {
                this._drawBoundingBoxes(this.boundingBoxes);
            } else {
                this._clearBoundingBoxes();
            }
        } catch (error) {
            console.error('Error during object detection:', error);
        }
    }

    _drawBoundingBoxes(boundingBoxes) {
        const colors = ['#7434eb', '#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#6c5ce7'];
        this._clearBoundingBoxes();
        boundingBoxes.forEach((box,index) => {
          const color = colors[index % colors.length];
          this.drawBoundingBox(box.x, box.y, box.width, box.height, color, 2);
        });
    }

    videoToggle(args) {
        const state = args.VIDEO_STATE;
        // Retrieve the camera state from localStorage
        let isCameraOpen;
        try {
            isCameraOpen = JSON.parse(localStorage.getItem('isCameraOpen'));
        } catch (error) {
            console.warn("Error accessing localStorage for camera state:", error);
            isCameraOpen = false; // Default to false if there's an error
        }
        if (state === 'off') {
            if (!isCameraOpen) {
                alert('Camera is already off.');
            } else {
                this.runtime.ioDevices.video.disableVideo();
                localStorage.setItem('isCameraOpen', JSON.stringify(false));
            }
        } else {
            if (isCameraOpen) {
                alert('Camera is already on.');
            } else {
                this.runtime.ioDevices.video.enableVideo().then(() => {
                    this.runtime.ioDevices.video.mirror = true;
                    localStorage.setItem('isCameraOpen', JSON.stringify(true));
                }).catch(err => {
                    console.error("Error enabling video: ", err);
                });
            }
        }
    }

    _initializePenLayer() {
        if (this.penSkinId < 0 && this.runtime.renderer) {
            this.penSkinId = this.runtime.renderer.createPenSkin();
            this.penDrawableId = this.runtime.renderer.createDrawable(StageLayering.PEN_LAYER);
            this.runtime.renderer.updateDrawableSkinId(this.penDrawableId, this.penSkinId);
            console.log('Pen layer initialized:', {
                penSkinId: this.penSkinId,
                penDrawableId: this.penDrawableId
            });
        }
    }

    drawBoundingBox(x, y, width, height, color = '#7434eb', thickness = 2) {
        if (this.penSkinId < 0) {
            console.warn('Pen layer is not initialized properly.');
            return;
        }

        // Log scaled coordinates for debugging
        console.log(`Drawing scaled bounding box at (${x}, ${y}) with width ${width} and height ${height}`);

        const colorObject = this._colorToRGBA(color);
        const penAttributes = {
            color4f: colorObject,
            diameter: thickness
        };

        // Adjust coordinates for Scratch coordinate system (origin at center)
        const stageWidth = 480;
        const stageHeight = 360;
        const adjustedX = x - (stageWidth / 2);
        const adjustedY = (stageHeight / 2) - y;

        // Draw bounding box using pen layer with adjusted coordinates
        const renderer = this.runtime.renderer;
        renderer.penLine(this.penSkinId, penAttributes,
            adjustedX, adjustedY,
            adjustedX + width, adjustedY); // Top edge
        renderer.penLine(this.penSkinId, penAttributes,
            adjustedX + width, adjustedY,
            adjustedX + width, adjustedY - height); // Right edge
        renderer.penLine(this.penSkinId, penAttributes,
            adjustedX + width, adjustedY - height,
            adjustedX, adjustedY - height); // Bottom edge
        renderer.penLine(this.penSkinId, penAttributes,
            adjustedX, adjustedY - height,
            adjustedX, adjustedY); // Left edge

        this.runtime.requestRedraw();
    }

    _colorToRGBA(color) {
        // Assuming color is in hex format, convert to normalized RGBA
        const rgb = parseInt(color.slice(1), 16);
        return [
            ((rgb >> 16) & 255) / 255, // R
            ((rgb >> 8) & 255) / 255,  // G
            (rgb & 255) / 255,         // B
            1                          // Alpha (fully opaque)
        ];
    }

    _clearBoundingBoxes() {
        if (this.penSkinId >= 0) {
            this.runtime.renderer.penClear(this.penSkinId);
            this.runtime.requestRedraw();
            console.log('Cleared pen layer.');
        }
    }

    getDetectedObjectCount() {
        return this.boundingBoxes.length;
    }

    getDetectedObjectProperty(args) {
        const index = Math.max(0, Math.floor(args.OBJECT_INDEX) - 1); // Convert to 0-based index
        const property = args.PROPERTY;
        if (index < this.boundingBoxes.length) {
            const object = this.boundingBoxes[index];
            switch (property) {
                case 'class':
                    return object.class;
                case 'x':
                    return Math.round(object.x);
                case 'y':
                    return Math.round(object.y);
                case 'width':
                    return Math.round(object.width);
                case 'height':
                    return Math.round(object.height);
                case 'confidence':
                    return Math.round(object.score * 100) + '%';
                default:
                    return 'Unknown property';
            }
        } else {
            return 'No object at this index';
        }
    }

    isClassDetected(args) {
        const classToCheck = args.CLASS;
        if (!classToCheck) {
            return false; // Return false if no class is selected
        }
        return this.detectedClasses.has(classToCheck);
    }

    getClassCount(args) {
        const classToCount = args.CLASS;
        if (!classToCount) {
            return 0; // Return 0 if no class is selected
        }
        return this.boundingBoxes.filter(box => box.class === classToCount).length;
    }

    setConfidenceThreshold(args) {
      let threshold = parseFloat(args.THRESHOLD);
      if (isNaN(threshold)) {
          threshold = 0.5;
      }
      // FIXED: Use more sensitive default threshold
      this.confidenceThreshold = Math.max(0.1, Math.min(1, threshold)); // Changed from 0 to 0.1 minimum
      console.log(`Confidence threshold set to: ${this.confidenceThreshold}`);
      return this.confidenceThreshold;
    }

    clearCanvas() {
        if (this.penSkinId >= 0 && this.runtime && this.runtime.renderer) {
            try {
                this.runtime.renderer.penClear(this.penSkinId);
                this.runtime.requestRedraw();
                console.log('Cleared pen layer.');
            } catch (e) {}
        }
        if (typeof document !== 'undefined') {
            try {
                const overlays = document.querySelectorAll('.stemblocks-detection-overlay, .stemblocks-detection-popup');
                overlays.forEach(el => el.remove());
            } catch (e) {}
        }
    }

    /**
     * Turn off camera, clear pen layer, and reset object detection state.
     * Called automatically on PROJECT_LOADED / RUNTIME_DISPOSED.
     */
    _cleanup() {
        // Turn off the camera
        try {
            if (this.video) {
                this.video.disableVideo();
            }
        } catch (e) {}

        // Clear pen drawings
        if (this.penSkinId >= 0 && this.runtime && this.runtime.renderer) {
            try {
                this.runtime.renderer.penClear(this.penSkinId);
                this.runtime.requestRedraw();
            } catch (e) {}
        }

        // Remove any loading/error popups still in the DOM
        if (typeof document !== 'undefined') {
            try {
                const overlays = document.querySelectorAll('.stemblocks-detection-overlay, .stemblocks-detection-popup');
                overlays.forEach(el => el.remove());
            } catch (e) {}
        }

        // Reset detection state
        this.boundingBoxes = [];
        this.detectedClasses = new Set();
    }

    dispose() {
        // Deregister event listeners to avoid memory leaks
        if (this.runtime && this._onProjectLoaded) {
            this.runtime.removeListener('PROJECT_LOADED', this._onProjectLoaded);
            this.runtime.removeListener('RUNTIME_DISPOSED', this._onProjectLoaded);
        }
        this._cleanup();
    }

}
module.exports = Scratch3ObjectDetectionExtension;